import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Register from "@/pages/Register";
import Admin from "@/pages/Admin";
import { WhatsAppFloating } from "@/components/WhatsAppFloating";
import { CountdownBanner } from "@/components/CountdownBanner";
import { RouteTracker } from "@/components/RouteTracker";
import { NewsletterPopup } from "@/components/NewsletterPopup";

const HomeWithPopup = () => (
  <>
    <Home />
    <NewsletterPopup />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteTracker />
        <Toaster
          theme="light"
          position="top-center"
          toastOptions={{
            style: {
              background: "#FBF6EA",
              border: "1px solid #D9C5A4",
              color: "#2A1810",
            },
          }}
        />
        <CountdownBanner />
        <Routes>
          <Route path="/" element={<HomeWithPopup />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <WhatsAppFloating />
      </BrowserRouter>
    </div>
  );
}

export default App;
